import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function Mobile({ children }) {
  const matches = useMediaQuery("(max-device-width:1023px), (orientation: portrait)");

  return matches ? <>{children}</> : <></>;
}
